
import { Vue, Component, Prop } from "vue-property-decorator";
import { OptionRecordsDto } from "@/api/service-proxies";import {
    VipPaySettingService,
    QRCodeContentSetting,
} from "@/api/service-proxies";

@Component({
    components: {},
})
export default class PayRecord extends Vue {
    dialogVisible = false;
    settingService = new VipPaySettingService();
    vipRecords = new QRCodeContentSetting();
schoolName=''
    open(qrCodeSetting:QRCodeContentSetting,name) {
        this.schoolName=name
        if(qrCodeSetting.id == 0){
           qrCodeSetting.gradeClassIsOpen = true;
           qrCodeSetting.studentNameIsOpen = true;
           qrCodeSetting.parentNameIsOpen = true;
        }
          this.vipRecords = qrCodeSetting;
        this.dialogVisible = true;
    }
    Changechecked(checked) {
        checked = !checked;
    }
    ChangeSwitch(switchs) {
        switchs = !switchs;
    }

    updateQrCodeSetting(){
        this.settingService.updateSchoolQrCodeSetting(this.vipRecords)
        .then((result)=>{
            this.$message.success("设置成功");
            this.$emit("success");
        })
        .catch((error)=>{
            this.$message.error("设置失败");
        })
        .finally(()=>{
            this.dialogVisible = false;
        })
    }

}
